<template>
<div class="columns is-gap is-multiline margin_gap">
  <div v-for="(faceLc, index) in detailPanneauxLc"
    :key="index"
    class="column is-half-tablet is-one-third-desktop">
    <div :class="{'selectt': faceLc.select}">
      <div class="container_img_info">
      <img :src="url(faceLc.extensionOpportunite.urlPhoto)" class="imageBg" alt="">
      <div class="dot_select" @click="contolSelect(index)"
          :class="{'dot_select1': faceLc.select}">
          <div class="dot_selected" v-if="faceLc.select"></div>
      </div>
      <div class="level is-mobile bgBlur" @click="afficheFace(index)">
        <div class="has-text-white">
          <div
            v-if="faceLc.extensionOpportunite.duree"
            class="media">
            <b-icon
              icon="timer"
              class="media-left margin_small">
            </b-icon>
            <div class="media-content is-size-7">
              <label> Durée : </label><br>
              <label class="has-text-weight-bold">
                {{faceLc.extensionOpportunite.duree}}
              </label>
            </div>
          </div>
        </div>
        <div
          class="level-right"
          v-if="getTarif">
          <h3 class="has-text-weight-bold has-text-white goToLeft">
            {{tarifAnnuel(getTarif(faceLc))}}
            {{faceLc.extensionOpportunite.tarifInformation}} HT
          </h3>
        </div>
      </div>
    </div>
    <div class="infoBorder has-background-white"
         @click="afficheFace(index)">
      <div class="leftViolet topViolet rightViolet bottomVert">
        <label class="has-text-default"> Adresse </label>
        <p class="has-text-dark has-text-weight-bold p_size12">
          {{adresse(faceLc)}}
        </p>
      </div>
      <div class="column leftViolet rightViolet">
        <div class="columns is-multiline is-mobile color-icon">
          <div class="column bottomVert is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Format
                </label>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{faceLc.format}}
                </p>
              </div>
            </div>
          </div>
          <div class="column bottomVert is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Support
                </label>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{faceLc.support}}
                </p>
              </div>
            </div>
          </div>
          <div class="column bottomVert is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="lightbulb-on-outline"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Éclairé
                </label>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{eclaire(faceLc.eclaire)}}
                </p>
              </div>
            </div>
          </div>
          <div class="column bottomVert is-paddingless is-6">
            <div
              v-if="faceLc.extensionOpportunite.dateDisponibilite"
              class="media">
              <b-icon
                icon="calendar-check"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">
                  Date de début
                </label>
                <p class="p_size12 has-text-weight-bold has-text-link">
                  {{dateDisponibilite(faceLc.extensionOpportunite.dateDisponibilite)}}
                </p>
              </div>
            </div>
          </div>
            <div class="column bottomVert is-paddingless is-12"
              v-if="faceLc.extensionOpportunite.commentaire">
              <div class="media">
                <div class="media-content">
                    <label class="has-text-weight-bold has-text-link p_size14">
                      Commentaire : </label><br>
                    <p class="p_size12 has-text-default has-text-link">
                      {{faceLc.extensionOpportunite.commentaire}}
                    </p>
                </div>
              </div>
            </div>
        </div>
      </div>
      <a>
        <p class="p_size14 has-text-centered has-text-white color-plus-info">
          Plus d'informations</p>
      </a>
    </div>
    </div>
  </div>
  <app-detail-opportunites :detailFaceLc="detailFaceLc" v-if="show"/>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatAdresse, formatNum, formatEclaire, formatDate, urlPhoto } from '@/services/opportunite/formatTab';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'listeFacesLc',
  props: ['detailPanneauxLc'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      show: false,
      detailFaceLc: {},
      bg: false,
    };
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect(i) {
      this.detailPanneauxLc[i].select = !this.detailPanneauxLc[i].select;
      if (this.detailPanneauxLc[i].select) {
        this.detailPanneauxLc[i].icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.getTarif(this.detailPanneauxLc[i]));
        this.addNbSelect();
      } else {
        this.detailPanneauxLc[i].icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.getTarif(this.detailPanneauxLc[i]));
        this.substractNbSelect();
      }
    },
    afficheFace(i) {
      this.detailFaceLc = this.detailPanneauxLc[i];
      this.show = true;
    },
    adresse(data) {
      return formatAdresse(data);
    },
    tarifAnnuel(t) {
      return formatNum(t);
    },
    eclaire(e) {
      return formatEclaire(e);
    },
    dateDisponibilite(d) {
      return formatDate(d);
    },
    url(u) {
      return urlPhoto(u);
    },
    getTarif(data) {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      if (data.extensionOpportunite.tarifDePose) {
        tarifDePose = data.extensionOpportunite.tarifDePose;
      }
      if (data.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = data.extensionOpportunite.taxeMunicipale;
      }
      if (data.extensionOpportunite.fraisTechnique) {
        fraisTechnique = data.extensionOpportunite.fraisTechnique;
      }
      if (data.extensionOpportunite.tarifNet) {
        tarifNet = data.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return data.extensionOpportunite.tarifAnnuel
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxLc/listesFacesLc.vue